<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form :model="percentage" :rules="rules" ref="percentage" label-width="100px" class="percentage-form" size="mini">
                    <el-form-item label="名称" prop="percentageName">
                        <el-input v-model="percentage.percentageName"></el-input>
                    </el-form-item>
                    <el-form-item label="总分成比例" prop="totalRatio">
                        <el-input v-model="percentage.totalRatio" type="number">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="销售比例" prop="salerRatio">
                        <el-input v-model="percentage.salerRatio" type="number" :min="0" :max="100">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="接单比例" prop="receiverRatio">
                        <el-input v-model="percentage.receiverRatio" type="number" :min="0" :max="100">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="辅助比例" prop="auxiliaryRatio">
                        <el-input v-model="percentage.auxiliaryRatio" type="number" :min="0" :max="100" >
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="操作比例" prop="operatorRatio">
                        <el-input v-model="percentage.operatorRatio" type="number" :min="0" :max="100" @blur="handleRatio('operator')" >
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    
                    <el-form-item label="主管比例" prop="directorRatio">
                        <el-input v-model="percentage.directorRatio" type="number"  :min="0" :max="100" @blur="handleRatio('director')">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="percentage.remark"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="row-button">
            <el-button type="primary" @click="submitForm('percentage')">提交</el-button>
            <el-button @click="cancel">取消</el-button>
        </el-row>
    </div>
</template>

<script>

    export default {
    name: "PercentageUpdate",
    props: ["percentageProp"],
    components: {
    },
    data() {

        var validateRatio = (rule, value, callback) => {
            //如果是已审核，则必填期限
            let reg = /^[0-9]+$/
            if(!reg.test(value)) {
                callback(new Error("请输入100以内正整数"));
            } else {
                if(value > 100) {
                    callback(new Error("请输入100以内正整数"));
                }
            }
            callback();
        };

        return {
            percentage: {
                percentageName: "",
            },
            rules: {
                percentageName: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                    { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                ],
                totalRatio: [
                    { required: true, message: "请输入总分成比例", trigger: "blur" },
                    { validator: validateRatio, trigger: "blur" }
                ],
                salerRatio: [
                    { required: true, message: "请输入销售比例", trigger: "blur" },
                    { validator: validateRatio, trigger: "blur" }
                ],
                receiverRatio: [
                    { required: true, message: "请输入接单比例", trigger: "blur" },
                    { validator: validateRatio, trigger: "blur" }
                ],
                auxiliaryRatio: [
                    { required: true, message: "请输入辅助比例", trigger: "blur" },
                    { validator: validateRatio, trigger: "blur" }
                ],
                operatorRatio: [
                    { required: true, message: "请输入操作比例", trigger: "blur" },
                    { validator: validateRatio, trigger: "blur" }
                ],
                directorRatio: [
                    { required: true, message: "请输入主管比例", trigger: "blur" },
                    { validator: validateRatio, trigger: "blur" }
                ]
            },
            dictTypeUserType: "user_type",
            dictTypeTeam: "team",
            dialogFormVisible: false,
            roles:[],
            restaurants: [],
            state: '',
            timeout:  null,
            dataStatuses: [],
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/percentage/save", this.percentage).then(res => {
                        if (res.data.status === "success") {
                            this.$message({
                                message: "提交成功！",
                                type: "success"
                            });
                            this.$bus.$emit(this.GlobeConstant.percentageupdate_to_percentage_close);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });

            
        },
        cancel() {
            this.$bus.$emit(this.GlobeConstant.percentageupdate_to_percentage_close);
        },
        createStateFilter(queryString) {
            return (state) => {
            return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleRatio(type) {
            if(type === 'operator') {
                if(this.percentage.salerRatio && this.percentage.receiverRatio && this.percentage.auxiliaryRatio){
                    var directorRate = 100- this.percentage.salerRatio - this.percentage.receiverRatio - this.percentage.operatorRatio - this.percentage.auxiliaryRatio;
                    this.$set(this.percentage,"directorRatio", directorRate);
                }
            }
            if(type === 'director') {
                if(this.percentage.salerRatio && this.percentage.receiverRatio && this.percentage.auxiliaryRatio){
                    var operatorRate = 100- this.percentage.salerRatio - this.percentage.receiverRatio- this.percentage.directorRatio - this.percentage.auxiliaryRatio;
                    this.$set(this.percentage,"operatorRatio", operatorRate);
                }
            }
        }
        
    },
    created() {
        this.percentage = this.percentageProp;
        if (this.percentageProp.percentageId) {
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
        }
    },
}


</script>

<style scoped>

   .percentage-form {
       margin: 20px 20px 20px 20px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .el-select {
        width: 100%;
    }
    .row-button {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
   }

   .row-button >.el-button {
        margin-top: 10px;
        margin-right: 10px;
   }

</style>
